<template>
  <div id="app">
    <div class="iframe">
      <iframe
              ref="iframe"
              src="./mms3D/index11.html"
              frameborder="0"
              style="width: 100%; height: 100%"
              id="iframe"
      ></iframe>
    </div>
    <HomeHeader></HomeHeader>
    <HomeBotton></HomeBotton>
    <router-view/>
  </div>
</template>
<script>
  import HomeHeader from "./components/homeHeader";
  import HomeBotton from "./components/homeBotton";
  export default {
    name: "app",
    components:{
      HomeHeader,
      HomeBotton
    },
    data(){
      return{

      }
    },
    mounted() {
    },
    methods:{

    }
  }
</script>
<style lang="scss">
  html,body{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;

  }
#app {
  width: 100%;
  height: 100%;
}
.iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
